import { Paper, Text, Grid, Anchor, List } from "@mantine/core";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
import {
  BUSINESS_HOURS,
  EMAIL,
  PHONE_DISPLAY,
  PHONE_NUMBER,
} from "../../constants/contact";
import { BusinessHourItem } from "./businessHourItem";

export function ContactDetails() {
  return (
    <Grid align="stretch">
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Paper p={"lg"} withBorder radius={"24px"} h="100%">
          <PhoneIcon
            height="48px"
            color={"var(--wallet-color-sambla-red-shade-600)"}
          />

          <Anchor
            href={`tel:${PHONE_NUMBER}`}
            display="block"
            mb={"lg"}
            mt={"lg"}
            c="dimmed"
          >
            <strong>{PHONE_DISPLAY}</strong>
          </Anchor>
          <List listStyleType="none">
            {BUSINESS_HOURS.map(({ day, hours }) => (
              <BusinessHourItem key={day + hours} hours={hours} day={day} />
            ))}
          </List>
        </Paper>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Paper p={"lg"} withBorder radius={"24px"} h="100%">
          <EnvelopeIcon
            height="48px"
            color={"var(--wallet-color-sambla-red-shade-600)"}
          />

          <Anchor
            href={`mailto:${EMAIL}`}
            display="block"
            mb={"lg"}
            mt={"lg"}
            c="dimmed"
          >
            <strong>{EMAIL}</strong>
          </Anchor>
          <Text>Vi svarar så fort vi kan! </Text>
          <Text>&nbsp;</Text>
          <Text>&nbsp;</Text>
        </Paper>
      </Grid.Col>
    </Grid>
  );
}
